var fieldBoxContent = 'content_fieldBoxContent__80ssm90';

export { fieldBoxContent };
//# sourceMappingURL=content.vanilla.mjs.map
